export const georgia = {
  "13000": "Georgia",
  "13001": "Appling County",
  "13003": "Atkinson County",
  "13005": "Bacon County",
  "13007": "Baker County",
  "13009": "Baldwin County",
  "13011": "Banks County",
  "13013": "Barrow County",
  "13015": "Bartow County",
  "13017": "Ben Hill County",
  "13019": "Berrien County",
  "13021": "Bibb County",
  "13023": "Bleckley County",
  "13025": "Brantley County",
  "13027": "Brooks County",
  "13029": "Bryan County",
  "13031": "Bulloch County",
  "13033": "Burke County",
  "13035": "Butts County",
  "13037": "Calhoun County",
  "13039": "Camden County",
  "13043": "Candler County",
  "13045": "Carroll County",
  "13047": "Catoosa County",
  "13049": "Charlton County",
  "13051": "Chatham County",
  "13053": "Chattahoochee County",
  "13055": "Chattooga County",
  "13057": "Cherokee County",
  "13059": "Clarke County",
  "13061": "Clay County",
  "13063": "Clayton County",
  "13065": "Clinch County",
  "13067": "Cobb County",
  "13069": "Coffee County",
  "13071": "Colquitt County",
  "13073": "Columbia County",
  "13075": "Cook County",
  "13077": "Coweta County",
  "13079": "Crawford County",
  "13081": "Crisp County",
  "13083": "Dade County",
  "13085": "Dawson County",
  "13087": "Decatur County",
  "13089": "DeKalb County",
  "13091": "Dodge County",
  "13093": "Dooly County",
  "13095": "Dougherty County",
  "13097": "Douglas County",
  "13099": "Early County",
  "13101": "Echols County",
  "13103": "Effingham County",
  "13105": "Elbert County",
  "13107": "Emanuel County",
  "13109": "Evans County",
  "13111": "Fannin County",
  "13113": "Fayette County",
  "13115": "Floyd County",
  "13117": "Forsyth County",
  "13119": "Franklin County",
  "13121": "Fulton County",
  "13123": "Gilmer County",
  "13125": "Glascock County",
  "13127": "Glynn County",
  "13129": "Gordon County",
  "13131": "Grady County",
  "13133": "Greene County",
  "13135": "Gwinnett County",
  "13137": "Habersham County",
  "13139": "Hall County",
  "13141": "Hancock County",
  "13143": "Haralson County",
  "13145": "Harris County",
  "13147": "Hart County",
  "13149": "Heard County",
  "13151": "Henry County",
  "13153": "Houston County",
  "13155": "Irwin County",
  "13157": "Jackson County",
  "13159": "Jasper County",
  "13161": "Jeff Davis County",
  "13163": "Jefferson County",
  "13165": "Jenkins County",
  "13167": "Johnson County",
  "13169": "Jones County",
  "13171": "Lamar County",
  "13173": "Lanier County",
  "13175": "Laurens County",
  "13177": "Lee County",
  "13179": "Liberty County",
  "13181": "Lincoln County",
  "13183": "Long County",
  "13185": "Lowndes County",
  "13187": "Lumpkin County",
  "13189": "McDuffie County",
  "13191": "McIntosh County",
  "13193": "Macon County",
  "13195": "Madison County",
  "13197": "Marion County",
  "13199": "Meriwether County",
  "13201": "Miller County",
  "13205": "Mitchell County",
  "13207": "Monroe County",
  "13209": "Montgomery County",
  "13211": "Morgan County",
  "13213": "Murray County",
  "13215": "Muscogee County",
  "13217": "Newton County",
  "13219": "Oconee County",
  "13221": "Oglethorpe County",
  "13223": "Paulding County",
  "13225": "Peach County",
  "13227": "Pickens County",
  "13229": "Pierce County",
  "13231": "Pike County",
  "13233": "Polk County",
  "13235": "Pulaski County",
  "13237": "Putnam County",
  "13239": "Quitman County",
  "13241": "Rabun County",
  "13243": "Randolph County",
  "13245": "Richmond County",
  "13247": "Rockdale County",
  "13249": "Schley County",
  "13251": "Screven County",
  "13253": "Seminole County",
  "13255": "Spalding County",
  "13257": "Stephens County",
  "13259": "Stewart County",
  "13261": "Sumter County",
  "13263": "Talbot County",
  "13265": "Taliaferro County",
  "13267": "Tattnall County",
  "13269": "Taylor County",
  "13271": "Telfair County",
  "13273": "Terrell County",
  "13275": "Thomas County",
  "13277": "Tift County",
  "13279": "Toombs County",
  "13281": "Towns County",
  "13283": "Treutlen County",
  "13285": "Troup County",
  "13287": "Turner County",
  "13289": "Twiggs County",
  "13291": "Union County",
  "13293": "Upson County",
  "13295": "Walker County",
  "13297": "Walton County",
  "13299": "Ware County",
  "13301": "Warren County",
  "13303": "Washington County",
  "13305": "Wayne County",
  "13307": "Webster County",
  "13309": "Wheeler County",
  "13311": "White County",
  "13313": "Whitfield County",
  "13315": "Wilcox County",
  "13317": "Wilkes County",
  "13319": "Wilkinson County",
  "13321": "Worth County",
};
